import Marquee from "react-fast-marquee";

const items = [
  "MADISON PRICE GROUP LLC",
  "FORGING FUTURES",
  "ACQUIRING EXCELLENCE",
  "BUILDING LEGACY",
];

export default function EditorialMarquee() {
  return (
    <section
      className="py-10 md:py-14 border-y border-[var(--mpg-border)] bg-[var(--mpg-surface)] overflow-hidden"
      data-testid="marquee"
    >
      <Marquee speed={30} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-4xl md:text-6xl lg:text-7xl text-[var(--mpg-text)] px-8 md:px-14">
              {t}
            </span>
            <span className="font-mono text-2xl md:text-4xl text-[var(--mpg-gold)]">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
